import {Spin} from 'antd';
import {useEffect, useState} from 'react';
import {config} from './configSlice';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import Page500 from '../Page500';
import EmplyoeeScreen from './EmployeeScreen';
import RackScreen from '../stationRackScreen/RackScreen';

const MainLayout = () => {
  const dispatch = useAppDispatch();
  const [isLoaded, setIsLoaded] = useState(false);
  const mainConfig = useAppSelector((state) => state.config);
  const [error, setError] = useState(false);
  useEffect(() => {
    dispatch(config())
      .unwrap()
      .then(() => setIsLoaded(true))
      .catch(() => {
        setError(true);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Spin spinning={mainConfig.isLoading} size={'large'} style={{marginTop: '40vh'}}>
      {isLoaded ? (
        mainConfig.config.is_station_employee ? (
          <RackScreen />
        ) : (
          <EmplyoeeScreen />
        )
      ) : (
        !mainConfig.isLoading && error && <Page500 />
      )}{' '}
    </Spin>
  );
};

export default MainLayout;
